export const CHIP_COLORS = {
  good: "#7FCA59",
  pending: "#FDA81F",
  failed: "#F65B5B",
  high: "#F65B5B",
  medium: "#FDA81F",
  low: "#7FCA59",
  info: "#007AFF",
  closed: "#7FCA59",
  open: "#F65B5B",
  investigation: "#FDA81F",
  warning: "#FDA81F",
  success: "#7FCA59",
  error: "#F65B5B",
};

export type ChipColorKey = keyof typeof CHIP_COLORS;

export const getChipColor = (status: string): string => {
  const key = status?.toLowerCase() as ChipColorKey;
  return CHIP_COLORS[key] || "#000000"; // Default or fallback
};
